<template>
  <div class="main-box">
    <ball></ball>
    <van-nav-bar
      title="量表列表"
      left-arrow
      left-text="返回"
      @click-left="onClickLeft"
    />
    <div class="body_list">
      <!-- <div class="gaugelist_title">问卷列表</div> -->
      <div
        class="gaugelist"
        v-for="(item, index) in gaugelist"
        :key="index"
        @click="gonext(item)"
      >
        <div class="gaugelist_name">{{ item.name }}</div>
        <div
          v-bind:class="
            item.dataStatus == 1 ? 'gaugelist_flag_a' : 'gaugelist_flag_b'
          "
        >
          {{ item.dataStatus == 1 ? "已测试" : "未测试" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import setOptions from "@/mixins/setOption";
import Nav from "@/components/nav.vue";
import { Dialog } from "vant";
import backindex from "@/mixins/backindex";
export default {
  mixins: [setOptions, backindex],
  data() {
    return {
      showempty: false,
      medCardNo: "",
      gaugelist: [
        //量表列表JSON
        {
          name: "AD8痴呆早期筛查问卷", //量表 名
          flag: "0", //量表的测试状态
          id: "1", //量表ID
        },
        {
          name: "焦虑状态调查",
          flag: "1", //暂用测试状态
          id: "2",
        },
        // {
        //   name: "抑郁状态调查",
        //   flag: "1", //暂用测试状态
        //   id: "3",
        // },
        // {
        //   name: "睡眠状况调查",
        //   flag: "1", //暂用测试状态
        //   id: "4",
        // },
      ],
      surveyId: "",
      clientId: "2021089458",
    };
  },
  components: {
    Nav,
  },

  created() {
    if (this.$route.query) {
      this.surveyId = this.$route.query.surveyId;
      this.medCardNo = this.$route.query.clientId;
      this.clinicId = this.$route.query.clinicId;
      // console.log(this.medCardNo)
    }
  if(!this.surveyId){
  
       this.surveyId = this.$local.get("surveyId");
  
  }
    // this.getquestionnairesurveyinfo();
  },
  mounted() {
    this.insertsurverclientinfo();
  },
  methods: {
    async insertsurverclientinfo() {
      try {
        this.$showLoad();
        let url = "/gauge/insertsurverclientinfo";
        let data = {
          surveyId: this.surveyId,
          clientId: this.medCardNo,
          id: `${this.medCardNo}_${this.surveyId}`,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            // console.log(data);
            // this.gaugelist = data.data.data.data;
            if (data.data.data.data) {
              this.getquestionnairesurveyinfo();
            } else {
              this.$toast.fail("网络出错");
            }
          }
        );
      } catch (error) {}
    },
    async getquestionnairesurveyinfo() {
      try {
        this.$showLoad();
        let url = "/gauge/questionarybysurveyclent";
        let data = {
          surveyId: this.surveyId,
          clientId: this.medCardNo,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            this.gaugelist = data.data.data.data;
            console.log(this.gaugelist);
          }
        );
      } catch (error) {}
    },
    gonext(item) {
      if (item.dataStatus == 1) {
        Dialog.confirm({
          message: "该量表已经测试，是否查看结果",
          confirmButtonText: "查看",
          cancelButtonText: "重做",
        })
          .then(() => {
            // on confirm
            this.$router.push({
              path: "/qrgaugeresult",
              query: {
                pid: this.clinicId,
                questionary: item.id,
                patientId: this.medCardNo,
                name: item.name,
                surveyId: this.surveyId,
              },
            });
          })
          .catch(() => {
            // on cancel
             this.$router.push({
          path: "/qrgaugesubject",
          query: {
            pid: this.clinicId,
            questionary: item.id,
            patientId: this.medCardNo,
            name: item.name,
            surveyId: this.surveyId,
          },
        });
          });
        // this.$router.push("/gaugeresult");
      } else {
        // this.$router.push("/gaugesubject");
        this.$router.push({
          path: "/qrgaugesubject",
          query: {
            pid: this.clinicId,
            questionary: item.id,
            patientId: this.medCardNo,
            name: item.name,
            surveyId: this.surveyId,
          },
        });
      }
    },
    goconfUser() {
      this.$router.push("/patient_card_confUser_C");
    },
    //
    onClickLeft() {
      this.$router.push("/index");
    },
    getyDay(date) {
      date.setTime(date.getTime());
      date =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      return date;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-box {
  width: 100vw;
  height: 100vh;
  background-color: white;
  .body_list {
    width: 100vw;
    .gaugelist_title {
      width: 100vw;
      height: 5vh;
      margin: 0px auto;
      line-height: 5vh;
      text-align: center;
      background-color: white;
      border-bottom: 1px solid rgb(241, 241, 241);
    }
    .gaugelist {
      width: 100vw;
      height: 15vh;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 16px;
      margin: 0px auto;
      background-color: white;
      border-bottom: 1px solid #eee;

      .gaugelist_name {
        line-height: 15vh;
        margin-left: 2vw;
        font-size: 18px;
        color: #666;
      }
      .gaugelist_flag_a {
        line-height: 15vh;
        margin-right: 2vw;
        font-size: 15px;
        color: #2ecc71;
      }
      .gaugelist_flag_b {
        line-height: 15vh;
        margin-right: 2vw;
        font-size: 15px;
        color: red;
      }
    }
  }
}
</style>